import React, { useEffect, useState } from "react";
import { LogoUpperContainer, LogoWrap } from "./style";
import { useSelector } from "react-redux";

function LogoForModal() {
  const { projectNamePoolName, corePoolAddress } = useSelector((state) => state.global);
  //TODO: change default url
  const [url, setUrl] = useState(
    "https://assets.turbologo.com/blog/en/2019/11/19084834/gaming-logo-cover.jpg"
  );

  return (
    <LogoUpperContainer>
      <LogoWrap>
        <img src={projectNamePoolName?.pool_url} />
      </LogoWrap>
      <h3 className="ml-3">
        {projectNamePoolName?.project_name + " - "}
        {projectNamePoolName?.pool_name
          ? projectNamePoolName?.pool_name
          : "Pool Name"}
      </h3>
    </LogoUpperContainer>
  );
}

export default LogoForModal;
